import React, { MouseEventHandler, ReactElement, Suspense, useState } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { CompanyInterface } from 'interfaces/company.interface';
import { numeralForm } from 'helpers/number';
import Link from 'atomic/link/link';
import LoadingOverlay from 'atomic/loading-overlay';

import opiconnectLogoSvg from 'assets/images/company-view/logo-opiconnect.inline.svg';

import './company-view-opiconnect.scss';

const CompanyViewOpiconnectModal = React.lazy(() => import('components/company-view/company-view-opiconnect/modal/company-view-opiconnect-modal'));

const CompanyViewOpiconnect: React.FC = (): ReactElement | null => {
    const company: CompanyInterface = useSelector((state: { company: CompanyInterface; }) => state.company);

    if (!company.opiconnectStatsPeriodic || !company.opiconnectStatsPeriodic[0]?.inProgressCount) {
        return null;
    }

    const [showModal, setShowModal] = useState(false);

    const handleClick: MouseEventHandler = e => {
        e.preventDefault();
        setShowModal(true);
    };

    return (
        <div className="container">
            <div className="company-view-opiconnect">
                {company.type === 'shop' ? 'Ten sklep ' : 'Ta firma '}
                posiada
                {' '}
                <span className="company-view-opiconnect__span">
                    {company.opiconnectStatsPeriodic[0].inProgressCount}
                </span>
                {' '}
                {numeralForm(
                    company.opiconnectStatsPeriodic[0].inProgressCount,
                    'trwającą reklamację',
                    'trwające reklamacje',
                    'trwających reklamacji'
                )}
                {' '}
                <Link className="company-view-opiconnect__button" href="#" wrapper={true} onClick={handleClick}>
                    <img src={opiconnectLogoSvg} alt="Opiconnect" className="company-view-opiconnect__logo" loading="lazy"/>
                </Link>

                {showModal && (
                    <Suspense fallback={<LoadingOverlay/>}>
                        <CompanyViewOpiconnectModal onClose={(): void => setShowModal(false)}/>
                    </Suspense>
                )}
            </div>
        </div>
    );
};

export default CompanyViewOpiconnect;
